import { setting } from './setting.model';

export const attachemntFieldSettings: Array<setting> = [
    { name: 'url', type: 'string'},
    { name: 'fileType', type: 'string'},
    { name: 'type', type: 'string'},
    { name: 'fileName', type: 'string'}
]